(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8346],{

/***/ 33591:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/catalogsearch/result",
      function () {
        return __webpack_require__(10750);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 10750:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ result; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 40 modules
var axios = __webpack_require__(6154);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/sweetalert/dist/sweetalert.min.js
var sweetalert_min = __webpack_require__(46737);
var sweetalert_min_default = /*#__PURE__*/__webpack_require__.n(sweetalert_min);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
// EXTERNAL MODULE: ./config.js
var config = __webpack_require__(83346);
// EXTERNAL MODULE: ./node_modules/js-cookie/dist/js.cookie.mjs
var js_cookie = __webpack_require__(31955);
// EXTERNAL MODULE: ./src/utils/convertPricePerSqmToSqFt.js
var convertPricePerSqmToSqFt = __webpack_require__(35620);
;// CONCATENATED MODULE: ./src/UnbxdProductCardResult.js









const UnbxdProductCardResult = (props)=>{
    var ref, ref1;
    let [mrp, setMrp] = (0,react.useState)(0);
    let [sellingPrice, seSellingPrice] = (0,react.useState)(0);
    let [outOfStock, setOutOfStock] = (0,react.useState)("Add to cart");
    const [AvailableStock, setAvailableStock] = (0,react.useState)(0);
    const getBestPrice = async (pin)=>{
        var ref, ref1, ref2, ref3;
        let apiresult = await axios/* default.get */.Z.get("https://obl-js.orientbell.com/api/product-availability-dev?sku=".concat(props.product.sku, "&pincode=").concat(pin, "&factory=").concat(props.product.tileFactoryProduction));
        if (((ref = apiresult.data) === null || ref === void 0 ? void 0 : (ref1 = ref.Plants) === null || ref1 === void 0 ? void 0 : ref1.length) > 0) {
            var ref4, ref5, ref6, ref7;
            let temparr = [];
            if (((ref4 = apiresult.data) === null || ref4 === void 0 ? void 0 : ref4.Plants.includes("Sikandrabad Plant")) && props.product.skdStock) {
                temparr.push(Number(props.product.skdStock));
            }
            if (((ref5 = apiresult.data) === null || ref5 === void 0 ? void 0 : ref5.Plants.includes("Dora Plant")) && props.product.doraStock) {
                temparr.push(Number(props.product.doraStock));
            }
            if (((ref6 = apiresult.data) === null || ref6 === void 0 ? void 0 : ref6.Plants.includes("Hoskote Plant")) && props.product.hoskoteStock) {
                temparr.push(Number(props.product.hoskoteStock));
            }
            if (((ref7 = apiresult.data) === null || ref7 === void 0 ? void 0 : ref7.Plants.includes("West Zone")) && props.product.westZoneStock) {
                temparr.push(Number(props.product.westZoneStock));
            }
            setAvailableStock(temparr.reduce((total, obj)=>total + obj, 0));
        } else {
            setAvailableStock("Not Deliverable");
        }
        if (((ref2 = apiresult.data) === null || ref2 === void 0 ? void 0 : ref2.transportOrder) == 0) {
            return;
        } else if ((ref3 = apiresult.data) === null || ref3 === void 0 ? void 0 : ref3.devliverytime) {
            var ref8;
            if ((ref8 = apiresult.data) === null || ref8 === void 0 ? void 0 : ref8.updated_price_ft) {
                var ref9;
                seSellingPrice((ref9 = apiresult.data) === null || ref9 === void 0 ? void 0 : ref9.updated_price_ft);
            }
            setOutOfStock("Add to cart");
        } else if (1 > apiresult.data.availableQty) {
            setOutOfStock("Out of Stock");
        } else if (apiresult.data.addesses == "" || !apiresult.data.devliverytime) {
            setOutOfStock("Not Deliverable in your Area");
        }
    };
    (0,react.useEffect)(()=>{
        if (js_cookie/* default.get */.Z.get("pincode")) {
            getBestPrice(js_cookie/* default.get */.Z.get("pincode"));
        }
        setMrp((0,convertPricePerSqmToSqFt/* default */.Z)(props.product.price));
        setAvailableStock([
            props.product.hoskoteStock,
            props.product.westZoneStock,
            props.product.doraStock,
            props.product.skdStock
        ].filter((cc)=>cc).reduce((total, obj)=>total + Number(obj), 0));
    }, [
        props
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "obl-searchresult-col unbxd-result-tile",
            id: props.product.sku,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    class: "cate-pro-figure",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: props.product.productUrl.replace("https://server.orientbell.com/", "/"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: ((ref = props.product.imageUrl) === null || ref === void 0 ? void 0 : ref.length) ? props.product.imageUrl[0] : ""
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    class: "cate-pro-text",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            class: "simi-name",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: props.product.productUrl.replace("https://server.orientbell.com/", "/"),
                                children: props.product.title
                            })
                        }),
                        sellingPrice && Number(mrp) > Number(sellingPrice) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mrp",
                            children: [
                                "Offer price ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: "₹."
                                }),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    style: {
                                        textDecoration: "line-through",
                                        marginRight: "5px"
                                    },
                                    children: [
                                        " ",
                                        Math.round(mrp),
                                        " "
                                    ]
                                }),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                    children: [
                                        " ",
                                        Math.round(sellingPrice),
                                        " /- Sq.ft "
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mrp",
                            children: [
                                "MRP ",
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                    children: [
                                        " ₹ ",
                                        Math.round(mrp),
                                        " /- Sq.ft"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            class: "produ-size",
                            children: [
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "produ-size-leftbox",
                                    children: [
                                        "Size",
                                        " ",
                                        ((ref1 = props.product.tileSize) === null || ref1 === void 0 ? void 0 : ref1.length) ? props.product.tileSize.join(" ,") : ""
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "produ-size-rightbox",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            style: {
                                                display: "inline-block",
                                                width: "10px",
                                                height: "10px",
                                                borderRadius: "50%",
                                                backgroundColor: AvailableStock > 0 && AvailableStock <= 100 ? "red" : AvailableStock > 100 && AvailableStock <= 250 ? "orange" : AvailableStock > 250 && AvailableStock <= 1000 ? "lightgreen" : AvailableStock > 1000 ? "darkgreen" : "grey",
                                                marginRight: "5px"
                                            }
                                        }),
                                        AvailableStock > 0 && AvailableStock <= 100 ? "Out of Stock" : AvailableStock > 100 && AvailableStock <= 250 ? "Low Stock" : AvailableStock > 250 && AvailableStock <= 1000 ? "Limited Stock" : AvailableStock > 1000 ? "In Stock" : AvailableStock == "Not Deliverable" ? "Not Deliverable" : "Out of Stock",
                                        " "
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            class: "add-button",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "".concat(props.product.productUrl.replace("https://server.orientbell.com/", "/")),
                                className: "add-pro-btn",
                                style: {
                                    backgroundColor: outOfStock == "Not Deliverable in your Area" ? "#a5a5a5" : outOfStock == "Out of Stock" ? "#ffcb08" : "#0b9444"
                                },
                                children: outOfStock
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var src_UnbxdProductCardResult = (UnbxdProductCardResult);

// EXTERNAL MODULE: ./api.services.js/others.js + 2 modules
var others = __webpack_require__(63372);
;// CONCATENATED MODULE: ./pages/catalogsearch/result/index.js








const SearchResult = (props)=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    const router = (0,next_router.useRouter)();
    const [products, setProducts] = (0,react.useState)();
    const [perPage, setPerPage] = (0,react.useState)(9);
    const [currentStart, setCurrentStart] = (0,react.useState)(0);
    const [TotalProd, setTotalProd] = (0,react.useState)(0);
    const [SortBy, setSortBy] = (0,react.useState)("*");
    const [mobileViewFilter, setMobileViewFilter] = (0,react.useState)(false);
    const [loadmore, setloadmore] = (0,react.useState)([]);
    const [pincode, setPinCode] = (0,react.useState)("");
    const [Statee, setStatee] = (0,react.useState)("");
    const [facets, setfacets] = (0,react.useState)(props.data.facets);
    const [AppliedFacet, setAppliedFacet] = (0,react.useState)({});
    let GetState = async (pin)=>{
        var ref, ref1, ref2;
        let pinInfo = await axios/* default.post */.Z.post("https://api.floraindia.com/api/zipinfo", {
            pincode: pin
        });
        if ((pinInfo === null || pinInfo === void 0 ? void 0 : (ref = pinInfo.data) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.PostOffice) === null || ref2 === void 0 ? void 0 : ref2.length) > 0) {
            var ref3, ref4;
            setStatee(pinInfo === null || pinInfo === void 0 ? void 0 : (ref3 = pinInfo.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.data) === null || ref4 === void 0 ? void 0 : ref4.PostOffice[0].State);
        }
    };
    (0,react.useEffect)(()=>{
        setProducts(props.data.response.products);
        setTotalProd(props.data.response.numberOfProducts);
        if (js_cookie/* default.get */.Z.get("pincode")) {
            setPinCode(js_cookie/* default.get */.Z.get("pincode"));
        }
        if (js_cookie/* default.get */.Z.get("pincode")) {
            GetState(js_cookie/* default.get */.Z.get("pincode"));
        }
    }, []);
    const getResultwithFacet = async (key, value, checked)=>{
        const result = {};
        let newArr = AppliedFacet[key] ? [
            ...AppliedFacet[key]
        ].filter((cc)=>cc !== value) : [];
        if (checked) newArr.push(value);
        const updatedFacets = {
            ...AppliedFacet,
            [key]: newArr
        };
        for (const [k, v] of Object.entries(updatedFacets)){
            if (v === null || v === void 0 ? void 0 : v.length) result[k] = v;
        }
        setAppliedFacet(result);
        setCurrentStart(0); // reset pagination
        const urlObj = new URL(props.unBxdUrl);
        Object.entries(result).forEach((param)=>{
            let [k, v] = param;
            const encoded = v.length > 1 ? v.map((f)=>"".concat(k, ':"').concat(f, '"')).join(" OR ") : "".concat(k, ':"').concat(v, '"');
            urlObj.searchParams.append("filter", encoded);
        });
        urlObj.searchParams.append("rows", perPage);
        urlObj.searchParams.append("start", 0); // reset to 0
        if (SortBy !== "*") urlObj.searchParams.append("sort", SortBy);
        try {
            const response = await axios/* default.get */.Z.get(urlObj.toString(), {
                headers: {
                    "unbxd-user-id": js_cookie/* default.get */.Z.get("unbxd.userId")
                }
            });
            setProducts(response.data.response.products);
            setTotalProd(response.data.response.numberOfProducts);
        } catch (error) {
            console.log("error");
            sweetalert_min_default()("Something went wrong please try again later");
        }
    // console.log(urlObj.toString());
    };
    const loadMore = async ()=>{
        const result = {};
        for (const [k, v] of Object.entries(AppliedFacet)){
            if (v === null || v === void 0 ? void 0 : v.length) result[k] = v;
        }
        const nextStart = currentStart + perPage;
        const urlObj = new URL(props.unBxdUrl);
        Object.entries(result).forEach((param)=>{
            let [k, v] = param;
            const encoded = v.length > 1 ? v.map((f)=>"".concat(k, ':"').concat(f, '"')).join(" OR ") : "".concat(k, ':"').concat(v, '"');
            urlObj.searchParams.append("filter", encoded);
        });
        urlObj.searchParams.append("rows", perPage);
        urlObj.searchParams.append("start", nextStart);
        if (SortBy !== "*") urlObj.searchParams.append("sort", SortBy);
        try {
            const response = await axios/* default.get */.Z.get(urlObj.toString(), {
                headers: {
                    "unbxd-user-id": js_cookie/* default.get */.Z.get("unbxd.userId")
                }
            });
            setProducts((prev)=>[
                    ...prev,
                    ...response.data.response.products
                ]);
            setTotalProd(response.data.response.numberOfProducts);
            setCurrentStart(nextStart); // update for next loadMore
        } catch (error) {
            console.log("error");
            sweetalert_min_default()("Something went wrong please try again later");
        }
    // console.log(urlObj.toString());
    };
    const applysort = async (s)=>{
        const result = {};
        for (const [k, v] of Object.entries(AppliedFacet)){
            if (v === null || v === void 0 ? void 0 : v.length) result[k] = v;
        }
        setSortBy(s);
        setCurrentStart(0); // reset
        const urlObj = new URL(props.unBxdUrl);
        Object.entries(result).forEach((param)=>{
            let [k, v] = param;
            const encoded = v.length > 1 ? v.map((f)=>"".concat(k, ':"').concat(f, '"')).join(" OR ") : "".concat(k, ':"').concat(v, '"');
            urlObj.searchParams.append("filter", encoded);
        });
        urlObj.searchParams.append("rows", perPage);
        urlObj.searchParams.append("start", 0);
        if (s !== "*") urlObj.searchParams.append("sort", s);
        try {
            const response = await axios/* default.get */.Z.get(urlObj.toString(), {
                headers: {
                    "unbxd-user-id": js_cookie/* default.get */.Z.get("unbxd.userId")
                }
            });
            setProducts(response.data.response.products);
            setTotalProd(response.data.response.numberOfProducts);
        } catch (error) {
            console.log("error");
            sweetalert_min_default()("Something went wrong please try again later");
        }
    // console.log(urlObj.toString());
    };
    const handleMobileFilter = ()=>{
        if (mobileViewFilter) {
            setMobileViewFilter(false);
        } else {
            setMobileViewFilter(true);
        }
    };
    const handlePinCodeChangeInput = (e)=>{
        setPinCode(e.target.value);
        const pincode = e.target.value * 1;
        if (e.target.value.length == 6) {
            (0,others/* savePincode */.y1)({
                pincodedetails: pincode
            });
            js_cookie/* default.set */.Z.set("pincode", pincode, {
                expires: 7
            });
            localStorage.setItem("pincode", pincode);
            localStorage.setItem("pincodeSkip", true);
            router.reload();
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "obl-searchresult-section",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "select-location-wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "TO FIND PRICES IN YOUR CITY, ENTER YOUR PINCODE"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "select-wraper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            value: pincode,
                            onChange: (e)=>handlePinCodeChangeInput(e)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    class: "obl-searchresult-row",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            class: "obl-searchresult-left",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mobile_view_filter",
                                    onClick: handleMobileFilter,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        children: "- Refine"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: mobileViewFilter ? "obl-searchresult-div filter-active" : "obl-searchresult-div",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            class: "ClearRefinements",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                class: "all-clear-btn",
                                                onClick: ()=>router.reload(),
                                                children: "Clear all"
                                            })
                                        }),
                                        facets === null || facets === void 0 ? void 0 : (ref = facets.text) === null || ref === void 0 ? void 0 : (ref1 = ref.list) === null || ref1 === void 0 ? void 0 : ref1.map((face)=>{
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                class: "searchresult-filter color",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        class: "title-bx",
                                                        children: face.displayName
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        class: "ais-HierarchicalMenu",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                            class: "ais-RefinementList-list",
                                                            children: loadmore.includes(face.displayName) && face.values.filter((f)=>typeof f != "number").length > 3 ? face.values.filter((f)=>typeof f != "number").map((cc)=>{
                                                                var ref, ref1;
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    className: "ais-RefinementList-item ".concat(((ref = AppliedFacet[face.facetName]) === null || ref === void 0 ? void 0 : ref.includes(cc)) ? "selected" : ""),
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                        class: "ais-RefinementList-label",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                                class: "ais-RefinementList-checkbox",
                                                                                type: "checkbox",
                                                                                onChange: (e)=>{
                                                                                    if (e.target.checked) {
                                                                                        getResultwithFacet(face.facetName, cc, true);
                                                                                    } else {
                                                                                        getResultwithFacet(face.facetName, cc, false);
                                                                                    }
                                                                                },
                                                                                checked: ((ref1 = AppliedFacet[face.facetName]) === null || ref1 === void 0 ? void 0 : ref1.length) ? AppliedFacet[face.facetName].includes(cc) : false
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                class: "ais-RefinementList-labelText",
                                                                                children: cc
                                                                            })
                                                                        ]
                                                                    })
                                                                });
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                children: [
                                                                    face.values.filter((f)=>typeof f != "number").slice(0, 3).map((cc)=>{
                                                                        var ref, ref1;
                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                            className: "ais-RefinementList-item ".concat(((ref = AppliedFacet[face.facetName]) === null || ref === void 0 ? void 0 : ref.includes(cc)) ? "selected" : ""),
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                                class: "ais-RefinementList-label",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                                        class: "ais-RefinementList-checkbox",
                                                                                        type: "checkbox",
                                                                                        onChange: (e)=>{
                                                                                            if (e.target.checked) {
                                                                                                getResultwithFacet(face.facetName, cc, true);
                                                                                            } else {
                                                                                                getResultwithFacet(face.facetName, cc, false);
                                                                                            }
                                                                                        },
                                                                                        checked: ((ref1 = AppliedFacet[face.facetName]) === null || ref1 === void 0 ? void 0 : ref1.length) ? AppliedFacet[face.facetName].includes(cc) : false
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                        class: "ais-RefinementList-labelText",
                                                                                        children: cc
                                                                                    })
                                                                                ]
                                                                            })
                                                                        });
                                                                    }),
                                                                    face.values.filter((f)=>typeof f != "number").length > 3 && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        onClick: ()=>{
                                                                            setloadmore([
                                                                                ...loadmore,
                                                                                face.displayName
                                                                            ]);
                                                                        },
                                                                        style: {
                                                                            color: "blue",
                                                                            marginBottom: "0px !important"
                                                                        },
                                                                        children: "load more"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    })
                                                ]
                                            });
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            class: "obl-searchresult-right",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "obl-searchresult-heading",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                            children: [
                                                "Results for",
                                                " ",
                                                ((ref2 = props.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.searchMetaData) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.fallback) === null || ref4 === void 0 ? void 0 : ref4.q) ? (ref5 = props.data) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.searchMetaData) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.fallback) === null || ref7 === void 0 ? void 0 : ref7.q : props.q
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "Check each product page for other buying options."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "searchresult-sort-bx",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                                value: SortBy,
                                                onChange: (e)=>{
                                                    applysort(e.target.value);
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        value: "*",
                                                        children: "Relevance"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        value: "price desc",
                                                        children: "Price (high to low)"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        value: "price asc",
                                                        children: "Price (low to high)"
                                                    })
                                                ]
                                            })
                                        }),
                                        Statee && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            class: "amshopby-filter",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    onClick: ()=>{
                                                        setStatee("");
                                                        js_cookie/* default.remove */.Z.remove("pincode");
                                                        localStorage.removeItem("pincode");
                                                        router.reload();
                                                    },
                                                    children: [
                                                        Statee,
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                            children: "X"
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "obl-searchresult-row",
                                    children: (products === null || products === void 0 ? void 0 : products.length) > 0 && products.map((prod, ii)=>{
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(src_UnbxdProductCardResult, {
                                            product: prod
                                        });
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    class: "load-more-product",
                                    children: TotalProd != (products === null || products === void 0 ? void 0 : products.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        type: "button",
                                        onClick: ()=>loadMore(),
                                        children: [
                                            "Load More from ",
                                            TotalProd - (products === null || products === void 0 ? void 0 : products.length)
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var result = (SearchResult);


/***/ }),

/***/ 35620:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ convertPricePerSqmToSqft; }
/* harmony export */ });
/**
 * Converts a given price in price-per-square-meter to price-per-square-foot
 *
 * @param {number} pricePerSqm - Price per square meter
 * @returns {number} - Price per square foot
 */ function convertPricePerSqmToSqft(pricePerSqm) {
    const conversionFactor = 10.7639;
    return (pricePerSqm / conversionFactor).toFixed(0);
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7361,5518,6737,3372,9774,2888,179], function() { return __webpack_exec__(33591); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);